import { addNotification } from '@onhandtech/onhand-fe-shared/lib/notifications'
import type { ReduxModuleResultPayloadAction } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { CreateSignupCodeResponse } from 'contracts/api/v4/signup-codes/create-signup-code.service'
import { signUpCodes as signUpCodesModule } from 'redux/redux-modules'
import { put } from 'redux-saga/effects'

export function* createSignupCodeSuccessSaga({
  payload,
  formatMessage,
}: ReduxModuleResultPayloadAction<CreateSignupCodeResponse>) {
  yield put(signUpCodesModule.actions.makeRequest())

  if (formatMessage) {
    yield put(
      addNotification({
        id: 'create-code-success',
        variant: 'success',
        title: formatMessage({
          id: 'notifications.signup-codes.create.success.title',
        }),
        description: formatMessage(
          {
            id: 'notifications.signup-codes.create.success.description',
          },
          { code: payload.code, organisation: payload.organisation.name },
        ),
      }),
    )
  }
}
